import { BaseTable, DashboardFilter, FooterMenu, HeaderMenu, Loading, PaginationData, TableHeader } from "components"
import moment from "moment"
import { useState } from "react"
import { DashboardFillType, PaginationState } from "types"
import { convertNumber, default_pagination_value, exportPdf } from "utils"
import { useCustomerOrderFullfilment } from "./utils/hooks/useCustomerOrderFullfilment"
import { ExportExcelCustomerOrderFullfilment } from "./components/exports/ExportExcelCustomerOrderFullfilment"
import { ExportPdfCustomerOrderFullfilment } from "./components/exports/ExportPdfCustomerOrderFullfilment"

type FilterType = DashboardFillType & PaginationState

export function CustomerOrderFullfilment() {
    const month = moment().format("MM")
    const year = moment().format("YYYY")
    const [fill, setFill] = useState<FilterType>({
        ...default_pagination_value,
        month,
        year,
    })
    const location_id = fill?.location_id

    const { data, isLoading, pagination, fetchAll } = useCustomerOrderFullfilment({
        year_month: `${fill.year}${fill.month}`,
        location_id: location_id,
        page: fill.page,
        limit: fill.limit
    })

    return (
        <section className="container my-5 flex flex-col gap-3">
            <HeaderMenu title="CUSTOMER ORDER FULLFILMENT" />

            <section className="flex flex-col gap-3">
                <section>
                    <DashboardFilter
                        onChangeFilter={(res) => setFill({
                            ...fill,
                            month: moment(res.date_from).format("MM"),
                            year: moment(res.date_from).format("YYYY"),
                            location_id: res.location_id
                        })}
                    />
                </section>

                <section className="flex flex-col mt-5">
                    <section className="grow">
                        <div className="max-h-[600px] overflow-y-auto">
                            <BaseTable>
                                <TableHeader>
                                    <tr>
                                        <th>CODE</th>
                                        <th>CUSTOMER NAME</th>
                                        <th>ORDER ID</th>
                                        <th>SHIPMENT DATE</th>
                                        <th>TOTAL QTY</th>
                                        <th>PROMISED DATE</th>
                                    </tr>
                                </TableHeader>
                                <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={6} className="text-center">
                                            <Loading loading={isLoading} errorText="No data available" />
                                        </td>
                                    </tr>
                                ) : data.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="text-center">
                                            <div className="text-center">No data available</div>
                                        </td>
                                    </tr>
                                ) : (
                                    data.map(item => (
                                        <tr key={item.customer_id}>
                                            <td className="text-left">{`${item?.customer_code ?? "-"}`}</td>
                                            <td className="text-left">{`${item?.customer_name ?? "-"}`}</td>
                                            <td className="text-left">{item.trx_code ?? "-"}</td>
                                            <td className="text-left">{moment(item.transaction_date).format('DD/MM/YYYY') ?? "-"}</td>
                                            <td className="text-right">{convertNumber(item.total_qty || 0)?.intoCurrency ?? "-"}</td>
                                            <td className="text-left">{moment(item.promize_date).format('DD/MM/YYYY') ?? "-"}</td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </BaseTable>
                        </div>
                        <div className="mt-5">
                            <PaginationData
                                data={{
                                    pagination_data: pagination
                                }}
                                pagination={fill}
                                setPagination={setFill as React.Dispatch<React.SetStateAction<PaginationState>>}
                            />
                        </div>
                    </section>
                </section>
                <section className="mt-2">
                    <FooterMenu
                        export={{
                            actiontype: "export",
                            onClick: async () => {

                                const fullData = await fetchAll();

                                ExportExcelCustomerOrderFullfilment({
                                    dataList: fullData || [],
                                })
                            }
                        }}
                        pdf={{
                            actiontype: "pdf",
                            onClick: async () => {

                                const fullData = await fetchAll();

                                exportPdf({
                                    documentComponent: <ExportPdfCustomerOrderFullfilment dataList={fullData || []} />,
                                    fileName: "Customer_Order_Fullfilment"
                                })
                            }
                        }}
                    />
                </section>
            </section>
        </section>
    )
}